<template>
  <div>
    Loading...
  </div>
</template>

<script>

  export default {
    name: 'Auth0Callback',
    data () {
      return {
          
      }
    },
  }
</script>

<style>

</style>